<template>
  <div class="row">
    <div class="col-12 overflow-hidden py-2">
      <div
        class="text-muted alert alert-info mt-2 animate__animated animate__fadeInDown animate__faster"
        style="line-height: 18px;">
        <div class="row">
          <div class="col-1 d-flex align-items-center justify-content-center">
            <i
              class="fa fa-info-circle"
              style="font-size: 20px;"/>
          </div>
          <div class="col-11">
            <small>
              Below are the available displays which you can assign to your customers. Please remember assigning a display to a customer indicates it is physically located at the store.
            </small>
          </div>
        </div>
      </div>
      <div
        class="float-end animate__animated animate__fadeIn animate__faster"
        style="width: 12em;">
        <span
          class="text-muted text-left"
          style="font-size: 12px; position: relative; left: 0em;">
          Filter by Priceline
        </span>
        <select
          class="form-select form-select-sm"
          v-model="selectedPriceline">
          <option value="">All</option>
          <option
            v-for="o in listOptions"
            :key="o"  
            :value="o">
            {{ o }}
          </option>
        </select>
      </div>
    </div>
    <div
      v-for="i in itemData"
      :key="i.id"
      class="col-12 col-sm-6 col-lg-4 col-xl-3 my-2 animate__animated animate__fadeIn animate__faster">
      <Item
        :item="i"
        :customer="customer"
        :merchIds="merchIds"/>
    </div>
  </div>
</template>

<script setup>
  import Item from './Item.vue';
  import { ref, computed } from 'vue';
  
  // Initialize
  const props = defineProps(['items', 'customer', 'merchIds'])

  // Data
  const selectedPriceline = ref('')

  // Computed
  const listOptions = computed(()=>{
    return _.uniq(_.map(props.items, 'priceLine')).sort()
  })

  const itemData = computed(()=>{
    if(selectedPriceline.value.length){
      return _.filter(props.items, i => i.priceLine == selectedPriceline.value)
    }
    return props.items
  })
  
</script>

<style scoped>
  select, option{
    cursor: pointer;
  }
</style>